import { render, staticRenderFns } from "./stedentScore.vue?vue&type=template&id=171849b5&scoped=true"
import script from "./stedentScore.vue?vue&type=script&lang=js"
export * from "./stedentScore.vue?vue&type=script&lang=js"
import style0 from "./stedentScore.vue?vue&type=style&index=0&id=171849b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "171849b5",
  null
  
)

export default component.exports